"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoQuoteBlockquotes = exports.getQuoteMarks = void 0;
var models_1 = require("@livv/models");
var OPENING_QUOTES = ['\u00AB', '\u201C', '"'];
var CLOSING_QUOTES = ['\u00BB', '\u201D', '"'];
var getQuoteMarks = function (language) {
    var isFr = language === models_1.Languages.fr;
    return {
        quoteOpen: isFr ? '\u00AB\u00A0' : '\u201C',
        quoteClose: isFr ? '\u00A0\u00BB' : '\u201D',
    };
};
exports.getQuoteMarks = getQuoteMarks;
var isBlockquoteLine = function (line) { return /^\s*>/.test(line); };
var parseBlockquoteLine = function (line) {
    var match = /^(\s*>\s?)(.*)$/.exec(line);
    if (!match) {
        return {
            content: line,
            isBlank: line.trim().length === 0,
            line: line,
            prefix: '',
        };
    }
    var _a = __read(match, 3), prefix = _a[1], content = _a[2];
    return {
        content: content,
        isBlank: content.trim().length === 0,
        line: line,
        prefix: prefix,
    };
};
var hasOpeningQuote = function (content) {
    var trimmed = content.trimStart();
    if (!trimmed)
        return false;
    return OPENING_QUOTES.some(function (quote) { return trimmed.startsWith(quote); });
};
var hasClosingQuote = function (content) {
    var trimmed = content.trimEnd();
    if (!trimmed)
        return false;
    return CLOSING_QUOTES.some(function (quote) { return trimmed.endsWith(quote); });
};
var TRAILING_CITATIONS_RE = /((?:[\s\u00A0\u202F\u2007]*\[\d+\](?:\([^)]*\))?)+)(\s*)$/;
var extractTrailingCitations = function (content) {
    var match = TRAILING_CITATIONS_RE.exec(content);
    if (!match) {
        return { body: content, citations: '', trailing: '' };
    }
    var _a = __read(match, 3), fullMatch = _a[0], citations = _a[1], _b = _a[2], trailing = _b === void 0 ? '' : _b;
    var body = content.slice(0, -fullMatch.length);
    return { body: body, citations: citations, trailing: trailing };
};
var addOpeningQuote = function (content, quoteOpen) {
    var _a, _b;
    if (hasOpeningQuote(content))
        return content;
    var leadingSpaces = (_b = (_a = content.match(/^\s*/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '';
    return "".concat(leadingSpaces).concat(quoteOpen).concat(content.slice(leadingSpaces.length));
};
var addClosingQuote = function (content, quoteClose) {
    var _a = extractTrailingCitations(content), body = _a.body, citations = _a.citations, trailing = _a.trailing;
    var core = body.replace(/\s*$/, '');
    if (hasClosingQuote(core))
        return content;
    return "".concat(core).concat(quoteClose).concat(citations).concat(trailing);
};
var autoQuoteBlockquotes = function (markdown, language) {
    if (!markdown)
        return markdown;
    var _a = (0, exports.getQuoteMarks)(language), quoteOpen = _a.quoteOpen, quoteClose = _a.quoteClose;
    var lines = markdown.split(/\r?\n/);
    var output = [];
    var index = 0;
    while (index < lines.length) {
        var line = lines[index];
        if (!isBlockquoteLine(line)) {
            output.push(line);
            index += 1;
            continue;
        }
        var blockStart = index;
        while (index < lines.length && isBlockquoteLine(lines[index])) {
            index += 1;
        }
        var blockLines = lines.slice(blockStart, index);
        var parsed = blockLines.map(parseBlockquoteLine);
        var cursor = 0;
        while (cursor < parsed.length) {
            if (parsed[cursor].isBlank) {
                output.push(parsed[cursor].line);
                cursor += 1;
                continue;
            }
            var paragraphStart = cursor;
            while (cursor < parsed.length && !parsed[cursor].isBlank) {
                cursor += 1;
            }
            var paragraphEnd = cursor;
            var firstLine = parsed[paragraphStart];
            var lastLine = parsed[paragraphEnd - 1];
            var firstContent = addOpeningQuote(firstLine.content, quoteOpen);
            var lastContent = addClosingQuote(paragraphStart === paragraphEnd - 1 ? firstContent : lastLine.content, quoteClose);
            for (var i = paragraphStart; i < paragraphEnd; i += 1) {
                var entry = parsed[i];
                var nextContent = entry.content;
                if (i === paragraphStart)
                    nextContent = firstContent;
                if (i === paragraphEnd - 1)
                    nextContent = lastContent;
                output.push("".concat(entry.prefix).concat(nextContent));
            }
        }
    }
    return output.join('\n');
};
exports.autoQuoteBlockquotes = autoQuoteBlockquotes;
//# sourceMappingURL=quotes.js.map